import React from 'react';

import { HostedFieldsFrame } from '../CreditCardForm.hostedFrame';
import type { CreditCardFormHostProps } from './CreditCardFormHost.types';

export const CreditCardFormHost = (props: CreditCardFormHostProps) => {
  return <HostedFieldsFrame {...props} />;
};
